import axios from "axios";
import { useCallback } from "react";
import useReporting from "./useReporting";
const useHttps = () => {
   const { apiErrorReportingService } = useReporting();
   const sendRequest = useCallback(
      async (
         { url, method, headers, data },
         callback,
         loadingFunc,
         errorCallback
      ) => {
         // eslint-disable-next-line no-undef
         const apiUrl = `${process.env.REACT_APP_URBC_API}${url}`;

         const config = {
            url: apiUrl,
            method,
            data,
            headers: {
               "Content-Type": "application/json",
               ...headers,
            },
         };
         try {
            loadingFunc && loadingFunc(true);

            const response = await axios(config);
            callback(response.data);
            loadingFunc && loadingFunc(false);
         } catch (err) {
            loadingFunc && loadingFunc(false);
            apiErrorReportingService(err?.response);
            errorCallback && errorCallback(err.response);
         }
      },
      []
   );
   return { sendRequest };
};

export default useHttps;
